var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-carousel',{attrs:{"cycle":"","interval":"3000","progress":"","height":"350","hide-delimiters":"","continuous":""}},_vm._l((_vm.sliders),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.image}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }